import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.08, duration: 0.65, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={fadeUp}
      custom={delay}
    >
      {children}
    </Tag>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`mask-line ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ delay, duration: 0.75, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ number, eyebrow, title, sub, dark = false }) => (
  <div className="max-w-3xl" data-testid={`section-heading-${eyebrow?.toLowerCase().replace(/\s+/g, "-")}`}>
    <Reveal>
      <div className="flex items-center gap-3 mb-5">
        <span className={`font-mono text-xs tracking-widest ${dark ? "text-teal-400" : "text-teal-700"}`}>
          {number}
        </span>
        <span className={`h-px w-10 ${dark ? "bg-teal-400/50" : "bg-teal-600/40"}`} aria-hidden="true" />
        <span className={`text-xs font-mono uppercase tracking-widest font-semibold ${dark ? "text-teal-300" : "text-teal-700"}`}>
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <Reveal delay={1}>
      <h2 className={`text-2xl sm:text-3xl lg:text-4xl font-serif font-bold tracking-tight text-balance ${dark ? "text-white" : "text-slate-900"}`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={2}>
        <p className={`mt-4 text-base sm:text-lg leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
